<template>
  <div class="contert">
    <div v-if="list.length > 0" class="musicList">
      <div  class="musicitems" v-for="(items, index) in list" :key="items.id">
        <div class="musicitem">
          {{ index + 1 + "." + items.audioName }}
          <div class="Listeningtovoice">
            <div
              class="Listeningtovoiceclick"
              v-if="items.audio_srcs != null"
              @click="playAudio1(items, index)"
            >
              <span>真人</span>
              <img
                v-show="!isShow1[index]"
                src="@/assets/images/off.png"
                alt=""
              />
              <img
                v-show="isShow1[index]"
                src="@/assets/images/no.png"
                alt=""
              />
            </div>
            <div
              class="Listeningtovoiceclick"
              v-if="items.audio_content != null"
              @click="playAudio2(items, index)"
            >
              <span>AI</span>
              <img
                v-show="!isShow2[index]"
                src="@/assets/images/off.png"
                alt=""
              />
              <img
                v-show="isShow2[index]"
                src="@/assets/images/no.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <p class="text" v-show="isShow[index]">
          {{items.audio_content}}
        </p>
      </div>
    </div>
    <audio :src="src" autoplay id="zhenren"></audio>
    <div class="ji">@AI语音由科大讯飞提供技术支持</div>
  </div>
</template>
<script>
import $ from "jquery";
import TtsRecorder from "@/assets/js/speechSynthesis/audio";
const ttsRecorder = new TtsRecorder();
export default {
  props: {
    listAplayer: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isShow1: [],
      isShow2: [],
      isShow: [],
      list: [],
      src: "",
      element: null,
      text: "",
    };
  },
  methods: {
    playAudio1(item, index) {
      let flag = (this.isShow1[index] = !this.isShow1[index]);
     
      this.isflaag();
       this.isShow[index] = true;
      if (!flag) {
        this.element.pause();
        return;
      }
      this.src = item.audio_srcs;
      this.isShow1.splice(index, 1, flag);
      this.element.play();
    },
    playAudio2(item, index) {
      this.text = item.audio_content;
      let flag = (this.isShow2[index] = !this.isShow2[index]);
      this.isflaag();
       this.isShow[index] = true;
      if (!flag) {
        return;
      }
      setTimeout(()=>{
        this.yuyin();
      },300)
      this.isShow2.splice(index, 1, flag);
    },
    isflaag() {
      if (this.element) {
        this.element.currentTime = 0;
        this.element.pause();
      }
      ttsRecorder.stop();
      this.isShow1 = [];
      this.isShow2 = [];
      this.isShow = [];
      this.listAplayer.forEach((v) => {
        this.isShow1.push(false);
        this.isShow2.push(false);
        this.isShow.push(false);
      });
    },
    yuyin() {
      //要合成的文本
      ttsRecorder.setParams({
        text: this.text,
        //  voiceName: '',
        speed: 50,
        voice: 50,
      });
      ttsRecorder.start();
    },
  },
  created() {
    this.list = this.listAplayer;
    this.$nextTick(() => {
      let audios = $("#zhenren");
      this.element = audios[0];
    });
    this.isflaag();
  },
  beforeDestroy() {
    ttsRecorder.stop();
    this.element.pause();
  },
};
</script>
<style scoped>
.contert {
  margin-top: 10px;
  margin-bottom: 20px;
  max-height: 400px;
  min-height: 100px;
  overflow: hidden;
  overflow-y: scroll;
}
.ji{
  display: flex;
  justify-content: center;
  color: #888;
  font-size: 12px;
  align-items: center;
  margin-top: 10px;
}
.Listeningtovoice {
  display: flex;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  align-items: center;
  justify-content: center;
}
.Listeningtovoice .Listeningtovoiceclick {
  width: 60px;
  height: 38px;
  background: #e95b2d;
  border-radius: 6px;
  color: #fff;
  padding: 0 6px;
  font-size: 12px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Listeningtovoice .Listeningtovoiceclick:last-child {
  margin-left: 4px;
}
.Listeningtovoice .Listeningtovoiceclick img {
  width: 20px;
  height: 20px;
  margin-left: 2px;
}
.musicList {
  display: flex;
  flex-direction: column;
}
.musicitem {
  display: flex;
  flex-direction: column;
  padding: 2px 12px;
  line-height: 40px;
  margin: 0 6px;
  font-size: 14px;
  box-shadow: 0 1px 6px rgba(95, 95, 95, 0.1);
  border-bottom: 1px solid rgb(228, 228, 228);
  position: relative;
  margin-bottom: 2px;
}
.text{
  margin: 10px 0;
  color: #333;
  padding: 0 20px;
  font-size: 12px;
}
.musicitems{
  overflow: hidden;
  width: 100%;
}
</style>